import moment from 'moment'
import { useContext, useEffect, useState } from 'react'

import { UserContext } from '../context'

const defaultGetDisplayTime = (dateText: string, timeText: string): string =>
  `${dateText} at ${timeText}`

export function useDateTime(
  date: string,
  config: {
    dateFormat?: string
    timeFormat?: string
    getDisplayTime?: (dateText: string, timeText: string) => string
  } = {},
) {
  const {
    dateFormat = 'dddd, MMM DD, YYYY',
    timeFormat = 'h:mmA',
    getDisplayTime = defaultGetDisplayTime,
  } = config

  const { currentUser } = useContext(UserContext)

  const [dateTime, setDateTime] = useState('')

  useEffect(() => {
    let MOMENT = moment(date).local()

    if (currentUser && currentUser.time_zone) {
      MOMENT = moment.tz(date, currentUser.time_zone)
    }

    const dateText = MOMENT.format(dateFormat) || ''
    let timeText = MOMENT.format(timeFormat) || ''

    timeText = timeText.replace(':00', '') // remove empty :00
    const displayText = getDisplayTime(dateText, timeText)
    setDateTime(displayText)
  }, [currentUser, date, dateFormat, dateTime, getDisplayTime, timeFormat])

  return dateTime
}
